import { MainMenuEntry } from '../types/main-menu-entry.type';
import { PUBLIC_EDITORIAL_APP_PATHS } from '../../../editorial/constants/public-editorial-paths.constants';

// L'arborescence relevée dans le menu legacy (src/components/Navbar.js). Les destinations restent
// à null tant que les pages correspondantes n'existent pas sous /v2 : renseigner un `path` ici
// suffit à rendre l'entrée cliquable, sans toucher au rendu.
export const MAIN_MENU_ENTRIES: MainMenuEntry[] = [
  {
    label: 'Commander',
    path: null,
  },
  {
    label: 'Engagement',
    path: null,
    children: [
      { label: 'Nos valeurs', path: PUBLIC_EDITORIAL_APP_PATHS.OUR_VALUES },
      { label: 'Nos producteurs', path: null },
      { label: 'Nos produits', path: PUBLIC_EDITORIAL_APP_PATHS.OUR_PRODUCTS },
      { label: 'Zéro déchet', path: PUBLIC_EDITORIAL_APP_PATHS.ZERO_WASTE },
    ],
  },
  {
    label: 'Offre entreprises',
    path: null,
    children: [
      { label: 'Une offre adaptée', path: PUBLIC_EDITORIAL_APP_PATHS.ENTERPRISE_OFFER },
      { label: 'Corbeille de fruits', path: PUBLIC_EDITORIAL_APP_PATHS.FRUIT_BASKET },
    ],
  },
  {
    label: 'Commande groupée',
    path: null,
    children: [
      { label: 'Comment ça marche', path: PUBLIC_EDITORIAL_APP_PATHS.GROUP_ORDER },
      { label: 'Ecopoints', path: PUBLIC_EDITORIAL_APP_PATHS.ECO_POINTS },
      { label: 'Devenir eco-acteur', path: null },
    ],
  },
  {
    label: 'Recettes',
    path: null,
  },
];
